<app-header-tela titulo="Entrega"></app-header-tela>

<form class="{{tema}}" [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
      novalidate #frm="ngForm" (ngSubmit)="onSubmit()" *ngIf="pedido">

  <!-- Card Principal -->
  <div class="entrega-container " *ngIf="pedido">

    <!-- Seção: Formas de Entrega -->
    <div class="entrega-card mt-2">
      <div class="card-header">
        <i class="fas fa-truck"></i>
        <h4 class="card-title">
          Forma de Entrega
          <ng-container *ngIf="apenasAgendamento">
            <span class="badge badge-warning ml-2">Apenas Agendamento</span>
          </ng-container>
        </h4>
      </div>

      <div class="card-body">
        <p *ngIf="empresa.id && !formasDeEntrega?.length" class="text-muted text-center">
          <i class="fas fa-info-circle"></i>
          Nenhuma forma de entrega está disponível no momento
        </p>

        <div class="formas-entrega-grid" *ngIf="formasDeEntrega?.length">
          <ng-container *ngFor="let formaEntrega of formasDeEntrega; let i = index">
            <div class="forma-entrega-item"
                 [ngClass]="{'selecionada': entrega.formaDeEntrega === formaEntrega.nome,
                             'indisponivel': formaEntrega.indisponivel}"
                 *ngIf="formaEntrega.ativa">

            <div class="radio-container">
              <input id="formaDeEntrega{{i}}"
                     name="formaDeEntrega{{i}}"
                     type="radio"
                     [(ngModel)]="entrega.formaDeEntrega"
                     [value]="formaEntrega.nome"
                     class="custom-radio"  [disabled]="formaEntrega.indisponivel"
                     (change)="alterouFormaDeEntrega(formaEntrega)" (click)="onAntesAlterarFormaEntrega($event, formaEntrega)"
                     [required]="true"/>
              <label for="formaDeEntrega{{i}}" class="radio-label">
                <div class="forma-icon">
                  <i class="fas" [ngClass]="{
                    'fa-hand-holding-usd': formaEntrega.nome === 'Retirar',
                    'fa-utensils': formaEntrega.nome === 'Comer no local',
                    'fa-home': formaEntrega.nome === 'Receber em casa',
                    'fa-truck': !formaEntrega.nome.includes('Retirar') && !formaEntrega.nome.includes('Comer') && !formaEntrega.nome.includes('Receber')
                  }"></i>
                </div>
                <div class="forma-info">
                  <span class="forma-nome">{{formaEntrega.nome}}</span>
                  <span class="forma-descricao" *ngIf="formaEntrega.descricao">{{formaEntrega.descricao}}</span>

                  <small *ngIf="formaEntrega.indisponivel" class="text-danger">
                   <i>Indisponível no momento, disponibilidade: <b>{{formaEntrega.descricaoHorario}}</b></i>
                  </small>
                </div>
              </label>
            </div>
          </div>
        </ng-container>
        </div>

        <div class="invalid-feedback" *ngIf="!entrega.formaDeEntrega">
          <i class="fas fa-exclamation-triangle"></i>
          <span>Escolha a forma de retirada do seu pedido</span>
        </div>
      </div>
    </div>

    <!-- Seção: Endereço para Delivery -->
    <div class="entrega-card" *ngIf="entrega.ehDelivery()">
      <div class="card-header">
        <i class="fas fa-map-marker-alt"></i>
        <h4 class="card-title">Endereço de Entrega</h4>
      </div>

      <div class="card-body">
        <ng-container *ngIf="entrega.endereco">
          <div class="endereco-selecionado">
            <div class="endereco-info">
              <i class="fas fa-check-circle text-success"></i>
              <div class="endereco-detalhes">
                <h6 class="endereco-titulo">Endereço Escolhido</h6>
                <p class="endereco-texto">{{entrega.endereco.obtenhaEnderecoCompleto()}}</p>
              </div>
            </div>

            <ng-container *ngIf="!escolherTipo">
              <button class="btn btn-outline-primary btn-sm" type="button"
                      *ngIf="entrega.endereco" (click)="alterarEndereco()">
                <i class="fas fa-edit"></i> Alterar
              </button>
            </ng-container>
          </div>

          <ng-container *ngIf="escolherTipo">
            <div class="escolha-tipo">
              <p class="escolha-titulo"><strong>Como você prefere informar?</strong></p>

              <ng-container *ngIf="possuiLocalizacao">
                <button class="btn btn-location btn-block" type="button" (click)="pegueLocalizacao()">
                  <i class="fas fa-search-location"></i>
                  <span>Usar Minha Localização</span>
                </button>

                <div class="divider">
                  <span>ou</span>
                </div>
              </ng-container>

              <button class="btn btn-blue btn-block" type="button"
                      *ngIf="entrega.endereco" (click)="informarEndereco()">
                <i class="fas fa-map-marked-alt"></i>
                Informar Endereço
              </button>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!entrega.endereco">
          <div class="sem-endereco" *ngIf="entrega.ehDelivery() && formaDelivery.priorizarLocalizacao">
            <div class="localizacao-prioritaria">
              <i class="fas fa-location-arrow"></i>
              <p class="text-center"><strong>Ative sua localização para informar seu endereço</strong></p>

              <ng-container *ngIf="possuiLocalizacao">
                <button class="btn btn-location btn-block" type="button" (click)="pegueLocalizacao()">
                  <i class="fas fa-search-location"></i>
                  <span>Usar Minha Localização</span>
                </button>
              </ng-container>

              <div class="alert alert-danger mt-3" *ngIf="msgErroLocalizacao">
                <i class="fas fa-exclamation-triangle"></i>
                <strong>{{msgErroLocalizacao}}</strong>
              </div>

              <button class="btn btn-outline-primary btn-block" type="button" (click)="informarEndereco()" *ngIf="erroLocalizacao">
                <i class="fas fa-map-marked-alt"></i>
                Informar Endereço
              </button>
            </div>
          </div>

          <div class="sem-endereco" *ngIf="entrega.ehDelivery() && !formaDelivery.priorizarLocalizacao">
            <ng-container *ngIf="!escolherTipo">
              <button class="btn btn-primary btn-block" type="button" (click)="alterarEndereco()">
                <i class="fas fa-plus"></i>
                Escolher Endereço
              </button>
            </ng-container>

            <ng-container *ngIf="escolherTipo">
              <div class="escolha-tipo">
                <p class="escolha-titulo"><strong>Como você prefere informar?</strong></p>

                <ng-container *ngIf="possuiLocalizacao">
                  <button class="btn btn-location btn-block" type="button" (click)="pegueLocalizacao()">
                    <i class="fas fa-search-location"></i>
                    <span>Usar Minha Localização</span>
                  </button>

                  <div class="divider">
                    <span>ou</span>
                  </div>
                </ng-container>

                <button class="btn btn-primary btn-block" type="button" (click)="informarEndereco()">
                  <i class="fas fa-map-marked-alt"></i>
                  Informar Endereço
                </button>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Seção: Taxa de Entrega -->
    <div class="entrega-card" *ngIf="entrega && entrega.taxaDeEntrega != null">
      <div class="card-header">
        <i class="fas fa-dollar-sign"></i>
        <h4 class="card-title">Taxa de Entrega</h4>
      </div>

      <div class="card-body">
        <div class="taxa-info">
          <div class="taxa-valor" *ngIf="entrega.taxaDeEntrega !== -1">
            <span class="taxa-label">Valor:</span>
            <span class="taxa-preco">{{entrega.taxaDeEntrega | currency: 'BRL'}}</span>
          </div>
          <div class="taxa-valor" *ngIf="entrega.taxaDeEntrega === -1">
            <span class="taxa-label">Status:</span>
            <span class="taxa-pendente">A Informar</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Seção: Agendar Entrega -->
    <div class="entrega-card" *ngIf="pedido.permiteAgendamento(pedido.entrega.formaDeEntrega, empresa.formasDeEntrega)">
      <div class="card-header">
        <i class="fas fa-calendar-alt"></i>
        <h4 class="card-title">Agendamento</h4>
      </div>

      <div class="card-body">
        <app-agendar-entrega [empresa]="empresa" [pedido]="pedido" [formasDeEntrega]="formasDeEntrega"
                             [agendarEntrega]="agendouEntrega || apenasAgendamento"
                             [apenasAgendamento]="apenasAgendamento"
                             [tela]="this"></app-agendar-entrega>


        <div class="invalid-feedback" *ngIf="agendarEntrega && (!pedido.dataEntrega || !pedido.horarioEntrega)">
          <i class="fas fa-exclamation-triangle mr-1"></i>
          <span>É necessário escolher o dia e horário da entrega</span>
        </div>

      </div>
    </div>


    <!-- Mensagem de Erro -->
    <div class="alert alert-danger mt-3" *ngIf="msgErro">
      <i class="fas fa-exclamation-triangle mr-1"></i>
      <strong>{{msgErro}}</strong>
    </div>
  </div>

  <!-- Espaçamento para o footer -->
  <div style="height: 80px"></div>

  <!-- Footer Fixo -->
  <footer class="footer {{empresa.tema}}" [ngClass]="{'powered-by': empresa.exibirPoweredBy}">
    <div class="footer-content">
      <div class="row" style="padding: 15px;">
        <div class="col"  [hidden]=" !entrega.foiPreenchida() && entrega.ehDelivery()">
          <button class="btn btn-primary btn-block btn-tema">Salvar Forma de Entrega</button>
        </div>
      </div>
    </div>

    <app-powered-by></app-powered-by>
  </footer>
</form>
